export default async function({ $setLanguageChoice, store, $storage, route }) {
  // If route.name is not equal to launcher we should set the language choice to get the POEditor translations
  // if not it will be handled by the launcher anyway
  if (route.name !== 'launcher') {
    const profile =
      store.state.gigyaProfile || $storage.getUniversal('gigyaProfile')

    if (profile) {
      const choice = await store.dispatch('getLanguageChoice')
      if (choice?.email === profile?.email) {
        const previousLanguage = choice.language || null
        if (route.name !== 'launcher' && previousLanguage) {
          return $setLanguageChoice(previousLanguage)
        }
      }
    }
  }
}
